import { useMemo } from "react";
import { resolvePotentiallyLocalizedString } from "@/utils/obj";

export const useResolvePotentiallyLocalizedString = (locale: string) =>
  useMemo(() => resolvePotentiallyLocalizedString(locale), [locale]);
